// extracted by mini-css-extract-plugin
export default {"header":"hero-styles_component_header__dY+ms"};